import { render, staticRenderFns } from "./ExpertizeShemeAddNew.vue?vue&type=template&id=3c8e88f8&"
import script from "./ExpertizeShemeAddNew.vue?vue&type=script&lang=js&"
export * from "./ExpertizeShemeAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports